import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "../../services/api";

// export const VerifyCredentials = createAsyncThunk(
//   "login/VerifyCredentials",
//   async (body) => {
//     const verifyDetails = await apiRequest.post("/login/", body);
//     return verifyDetails.data;
//   }
// );

export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async () => {
    const verifyDetails = await apiRequest.get("v1/profile/");
    return verifyDetails.data;
  }
);

// User 2FA otpauth apis
export const fetchUser2FAOtpUrl = createAsyncThunk(
  "profile/fetch_user_2fa_otp",
  async (body) => {
    const profile2faOtpCreate = await apiRequest.get(`v1/totp/create/`, {
      headers: { organization: body.userOrganization.org_id },
    });
    return profile2faOtpCreate.data;
  }
);
export const verifyUser2FAOtp = createAsyncThunk(
  "profile/verify_user_2fa_otp",
  async (body) => {
    const profile2faOtpVerify = await apiRequest.post(
      `v1/totp/verify/`,
      body.value,
      { headers: { organization: body.userOrganization.org_id } }
    );
    return profile2faOtpVerify.data;
  }
);
export const deleteUser2FAOtp = createAsyncThunk(
  "profile/delete_user_2fa_otp",
  async (body) => {
    const profile2faOtpDelete = await apiRequest.delete("v1/totp/delete/", {
      headers: { organization: body.userOrganization.org_id },
    });
    return profile2faOtpDelete.data;
  }
);

// Profile password change
export const changeProfilePassword = createAsyncThunk(
  "profile/change_profile_pwd",
  async (body, { rejectWithValue }) => {
    try {
      const profileChangePwd = await apiRequest.post(
        `v1/change_password/`,
        body.value,
        { headers: { organization: body.userOrganization.org_id } }
      );
      return profileChangePwd;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
